import moment from 'moment'

moment.locale('es')

class CopyWeeklyService {
  static savedCopiedTaskOfWeek (start, finish, tasks) {
    let object = {
      start: this.formatDate(start),
      finish: this.formatDate(finish),
      tasks: tasks
    }

    localStorage.setItem('copiedTasks', JSON.stringify(object))
  }

  static getCopiedTaskOfWeek () {
    let data = this.getStorageCopiedTasks()

    let start = data ? this.toDate(data.start) : null
    let finish = data ? this.toDate(data.finish) : null
    let tasks = data ? data.tasks : null

    return {
      start,
      finish,
      tasks
    }
  }

  static clearCopiedTasksOfWeek () {
    let object = {
      start: null,
      finish: null,
      tasks: null
    }

    localStorage.setItem('copiedTasks', JSON.stringify(object))
  }

  static getStorageCopiedTasks () {
    return JSON.parse(localStorage.getItem('copiedTasks'))
  }

  static isValidDate (date) {
    return moment(date).isValid()
  }

  static formatDate (date) {
    if (this.isValidDate(date)) {
      return moment(date).format('YYYY-MM-DD')
    } else {
      return null
    }
  }

  static toDate (stringDate) {
    if (stringDate) {
      return moment(stringDate, 'YYYY-MM-DD').toDate()
    } else {
      return null
    }
  }
}

export default CopyWeeklyService
